import script from "./TrekAvantyCheck.vue?vue&type=script&lang=js"
export * from "./TrekAvantyCheck.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__